<template id="Simulateur">
	<div id="app">
		<div id="form-group" class="form-group Gradient fade-in">
	   	<div v-if="show_inputs()" class="inputs">
	   		<div>
	   			<div class="label" ><label for="demarche">Choisissez votre démarche</label></div>
				<div><select v-model="demarche" id="demarche" name="demarche" type="select" class="simu-input">
					<option value="00" selected="true">Changement de titulaire véhicule occasion</option>
					<option value="01">Changement d'adresse</option>
					<option value="02">Duplicata</option>
					<option value="03">Changement de caractéristique technique</option>
					<option value="04">Succession</option>
					<option value="05">Veuvage - Changement d'état matrimonial</option>
					</select>
				</div>
				
			</div>
			<div>
				<div class="label" v-bind:class="{error:error_immat}"><label for="immat">Saisissez votre n° d'immatriculation</label></div>
				<div><input v-model="immat" id="immat" name="immat" type="text" class="simu-input immat-imput" v-bind:class="{error_input:error_immat}" placeholder="AA-123-BB"></div>
				
			</div>
			<div>
				<div class="label" v-bind:class="{error:error_dpt}">
					<label for="dpt">Séléctionnez votre département</label>
				</div>
				<div><select v-model="dpt" id="dept" name="dpt" type="select" class="simu-input" v-bind:class="{error_input:error_dpt}">
				<option value="00">Département</option>
				<option value="01">01 - Ain</option>
				<option value="02">02 - Aisne</option>
				<option value="03">03 - Allier</option>
				<option value="04">04 - Alpes de Haute Provence</option>
				<option value="05">05 - Hautes Alpes</option>
				<option value="06">06 - Alpes Maritimes</option>
				<option value="07">07 - Ard&#232;che</option>
				<option value="08">08 - Ardennes</option>
				<option value="09">09 - Ari&#232;ge</option>
				<option value="10">10 - Aube</option>
				<option value="11">11 - Aude</option>
				<option value="12">12 - Aveyron</option>
				<option value="13">13 - Bouches du Rh&#244;ne</option>
				<option value="14">14 - Calvados</option>
				<option value="15">15 - Cantal</option>
				<option value="16">16 - Charente</option>
				<option value="17">17 - Charente Maritime</option>
				<option value="18">18 - Cher</option>
				<option value="19">19 - Corr&#232;ze</option>
				<option value="2A">2A - Corse du Sud</option>
				<option value="2B">2B - Haute-Corse</option>
				<option value="21">21 - C&#244;te d'Or</option>
				<option value="22">22 - C&#244;tes d'Armor</option>
				<option value="23">23 - Creuse</option>
				<option value="24">24 - Dordogne</option>
				<option value="25">25 - Doubs</option>
				<option value="26">26 - Dr&#244;me</option>
				<option value="27">27 - Eure</option>
				<option value="28">28 - Eure et Loir</option>
				<option value="29">29 - Finist&#232;re</option>
				<option value="30">30 - Gard</option>
				<option value="31">31 - Haute Garonne</option>
				<option value="32">32 - Gers</option>
				<option value="33">33 - Gironde</option>
				<option value="34">34 - H&#233;rault</option>
				<option value="35">35 - Ille et Vilaine</option>
				<option value="36">36 - Indre</option>
				<option value="37">37 - Indre et Loire</option>
				<option value="38">38 - Is&#232;re</option>
				<option value="39">39 - Jura</option>
				<option value="40">40 - Landes</option>
				<option value="41">41 - Loir et Cher</option>
				<option value="42">42 - Loire</option>
				<option value="43">43 - Haute Loire</option>
				<option value="44">44 - Loire Atlantique</option>
				<option value="45">45 - Loiret</option>
				<option value="46">46 - Lot</option>
				<option value="47">47 - Lot et Garonne</option>
				<option value="48">48 - Loz&#232;re</option>
				<option value="49">49 - Maine et Loire</option>
				<option value="50">50 - Manche</option>
				<option value="51">51 - Marne</option>
				<option value="52">52 - Haute Marne</option>
				<option value="53">53 - Mayenne</option>
				<option value="54">54 - Meurthe et Moselle</option>
				<option value="55">55 - Meuse</option>
				<option value="56">56 - Morbihan</option>
				<option value="57">57 - Moselle</option>
				<option value="58">58 - Ni&#232;vre</option>
				<option value="59">59 - Nord</option>
				<option value="60">60 - Oise</option>
				<option value="61">61 - Orne</option>
				<option value="62">62 - Pas de Calais</option>
				<option value="63">63 - Puy de D&#244;me</option>
				<option value="64">64 - Pyr&#233;n&#233;es Atlantiques</option>
				<option value="65">65 - Hautes Pyr&#233;n&#233;es</option>
				<option value="66">66 - Pyr&#233;n&#233;es Orientales</option>
				<option value="67">67 - Bas Rhin</option>
				<option value="68">68 - Haut Rhin</option>
				<option value="69">69 - Rh&#244;ne</option>
				<option value="70">70 - Haute Sa&#244;ne</option>
				<option value="71">71 - Sa&#244;ne et Loire</option>
				<option value="72">72 - Sarthe</option>
				<option value="73">73 - Savoie</option>
				<option value="74">74 - Haute Savoie</option>
				<option value="75">75 - Paris</option>
				<option value="76">76 - Seine Maritime</option>
				<option value="77">77 - Seine et Marne</option>
				<option value="78">78 - Yvelines</option>
				<option value="79">79 - Deux S&#232;vres</option>
				<option value="80">80 - Somme</option>
				<option value="81">81 - Tarn</option>
				<option value="82">82 - Tarn et Garonne</option>
				<option value="83">83 - Var</option>
				<option value="84">84 - Vaucluse</option>
				<option value="85">85 - Vend&#233;e</option>
				<option value="86">86 - Vienne</option>
				<option value="87">87 - Haute Vienne</option>
				<option value="88">88 - Vosges</option>
				<option value="89">89 - Yonne</option>
				<option value="90">90 - Territoire de Belfort</option>
				<option value="91">91 - Essonne</option>
				<option value="92">92 - Hauts de Seine</option>
				<option value="93">93 - Seine Saint Denis</option>
				<option value="94">94 - Val de Marne</option>
				<option value="95">95 - Val d'Oise</option>
				<option value="971">971 - Guadeloupe</option>
				<option value="972">972 - Martinique</option>
				<option value="973">973 - Guyane</option>
				<option value="974">974 - R&#233;union</option>
				<option value="975">975 - Saint Pierre et Miquelon</option>
				<option value="976">976 - Mayotte</option>
				</select></div>
			</div>
		</div>
		<div class ="vehicule" v-if="show_vehicule()">
			<Vehicule></Vehicule>
		</div>
		<div v-if="error_immat||error_dpt">
			<p v-if="error_immat" class="error_txt">{{this.error_immat_text}}</p>
			<p v-if="error_dpt" class="error_txt">{{this.error_dpt_text}}</p>
		</div>
			<div class="calculer">
				<button id='calculer' @click="misiv()">Calculer le tarif</button>
			</div>
				<div v-if="show_load" class="gauge-loader load_calcul">
				Loading...
				</div>
			</div>
	</div>
</template>

<script>
	import Vehicule from './Vehicule.vue'
	import firebase from 'firebase'
	import axios from 'axios'
	import $ from 'jquery'
	export default {
		props:['id'],
	components:{Vehicule},
	name: 'Simulateur',
	data () {
		return {
   			error_immat:false,
   			error_dpt:false,
   			error_immat_text:"",
   			error_dpt_text:"",
			show_result:false,
			show_load:false,
			demarche:"00",
			immat:"",
			dpt:"00",
			prix:"",
			vin:"",
			mec:"",
			pump:false,
			logo_path:"citroen"
		}
	},
	methods: {
		show_inputs(){
			return !this.$store.state.vehicule.completed;
		},
		show_vehicule(){
			return this.$store.state.vehicule.completed;
		},
		test_immat(){
			var test_immat = this.immat.toUpperCase().split("-").join("").split(" ").join("");
			var re_old = /^[0-9]{1,4}[A-Z]{2,3}[0-9]{2}$/
			var re_new = /^[A-Z]{2}[0-9]{3}[A-Z]{2}$/
			if(re_old.test(test_immat)){
				var new_immat = test_immat.split("");
				var type = "number";
				var new_immat2 = "";
				new_immat.forEach((str,i,arr)=>{
					if(isNaN(str)){
						if(type=='number'){
							new_immat2 += "-";
							new_immat2 += str;
							type = "string";
						}else{
							new_immat2 += str;
						}
					}else{
						if(type=="string"){
							new_immat2 += "-";
							new_immat2 += str;
							type = "number";
						}else{
							new_immat2 += str;
						}
					}
				});
				this.immat=new_immat2;
				return {result:true,type_immat:"fni"}
			}else if(re_new.test(test_immat)){
				var new_immat = test_immat.split("");
				var new_immat2 = new_immat[0]+new_immat[1]+"-"+new_immat[2]+new_immat[3]+new_immat[4]+"-"+new_immat[5]+new_immat[6];
				this.immat=new_immat2
				return {result:true,type_immat:"siv"}
			}else{
				return {result:false}
			}
		},
		misiv(){
			var go = true;
			if(this.$store.state.vehicule.completed){
				this.$router.push('/go/immatriculation')
			}else{
				if(this.immat == ""){
					// console.log("immat emply");
					this.error_immat=true;
					this.error_immat_text="Veuillez saisir un numéro d'immatriculation.";
					go=false;
				}else{
					this.error_immat=false;
				}
				if(this.dpt == "00"){
					// console.log("dpt emply")
					this.error_dpt=true;
					this.error_dpt_text="Veuillez sélectionner un département.";
					go=false;
				}else{
					this.error_dpt=false;
				}
				var test_immat = this.test_immat();
				if(test_immat.result){
					this.error_immat=false;
				}else{
					this.error_immat=true;
					this.error_immat_text="Veuillez saisir un numéro d'immatriculation valide (au format AA-123-BB (SIV) ou 1-AA-22 ou 11-AAA-22 ... (FNI).";
					go=false;
				}
				if(go){
					this.show_load=true //affiche le curseur de chargement
					//console.log("go! InfoImmat executed");
					firebase.auth().signInAnonymously()
  					.then(() => {
						var add_vehicule = this.$store.dispatch('addVehicule',{
							immat:this.immat,
							type_immat:test_immat.type_immat,
							dpt:this.dpt,
							demarche:this.demarche
						}).then(response => {
							//console.log(response);
							this.show_load=false //cache le curseur de chargement
							this.$router.push('/go/immatriculation')

						}).catch(error =>{
							//console.log(error);
							this.show_load=false //cache le curseur de chargement
						});
					}).catch((error) => {
						//console.log(error)
					});
				}else{
					//console.log('AddMessage non executed')
				}
			}
		}
	},
	mounted () {
		if(this.id != "Home_simulateur"){
			document.getElementById("form-group").classList.add("form-group-outside-home");
		}else{
			document.getElementById("form-group").classList.add("form-group-home");
		}
		//console.log(this.id)
	}
	// directives: {
	//   clickoutside: {
	// 	  bind: function (el, binding, vnode) {
	// 	    el.clickOutsideEvent = function (event) {
	// 	      // here I check that click was outside the el and his childrens
	// 	      if (!(el == event.target || el.contains(event.target))) {
	// 	        // and if it did, call method provided in attribute value
	// 	        vnode.context[binding.expression](event);
	// 	      }
	// 	    };
	// 	    document.body.addEventListener('click', el.clickOutsideEvent)
	// 	   },
	// 	  unbind: function (el) {
	// 	    document.body.removeEventListener('click', el.clickOutsideEvent)
	// 	   },
	// 	  stopProp(event) { event.stopPropagation() }
	// 	  }
	//   },
}
</script>

<style scoped>
/*.show{
  width:200px;
  height:40px;
  background:white;
}
#shopcartpreview{
  background:gold;
  height:300px;
   width:200px;
}*/

.result p{
	text-align:center;
	color:white;
	font-size:1.2em;
}
#simulateur{
	//background-color:#22407a;
	//padding:40px 10px 30px 10px;
}
.loader {
	margin: 0 auto;
	border: 4px solid #f3f3f3; /* Light grey */
	border-top: 4px solid #3498db; /* Blue */
	border-radius: 50%;
	width: 20px;
	height: 20px;
	animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
/*.active{
	background-color:#22407a;
	padding:0px 10px 30px 10px;
}*/
.label, .error_txt{
	text-align:center;
    //position:absolute;
    color:#ffffeb;
    font-weight:400;
    /*font-style:italic;*/
    overflow:auto;
/*    text-decoration:underline;
    text-decoration-color:orange;*/
    font-size:0.8em;
}
.error{
	/*color:#e17055;*/
	text-decoration:underline;
}
.form-group{
	display:flex;
	flex-direction:column;
	//justify-content:center;
	align-items:center;
	width:100%;
	//flex-wrap:wrap;
	//position:absolute;
	padding-top:10px;
	padding-bottom:20px;
	//border-radius:0px 0px 30px 30px;
	background-repeat:no-repeat;
	background-color: #22417B;
	background-image: url(../assets/cartegrise_main.png);/*linear-gradient(180deg, rgba(16,11,91,1) 0%, rgba(34,64,122,1) 100%)*/;
	background-size:140px,auto;
	background-position:bottom 0px left 40px, bottom 0px left 0px;
	box-shadow: 0px 2px 2px #1a1a1a;
}
.form-group-outside-home{
	background:#22417B;
}
.form-group-home{
	padding-top: 30px;
	padding-bottom: 25px;
}

.form-group *{
	margin-right:10px;
	margin-left:10px;
	padding:5px 0px 5px 0px;
}
.inputs{
	padding-top:30px;
	display:flex;
	align-items:center;
	justify-content:center;
	width:80%;
	flex-wrap:wrap;
}

.simu-input {
    text-align: center;
    //width: auto;
    //height: auto;
    background-color: #FFFFFF;
	border: 1px solid #b1bcc4;
	border-radius: 4px;
	color: #565656;
	//padding: 7px 12px;
	height: 38px;
	width:300px;
	max-width: 100%;
	box-shadow: none;
}
.simu-input option{
	text-align:center;
}
.immat-imput{
	font-size: 210% !important;
    background-image: url(../assets/plaquefr.png);
    background-position: 1px 1px;
    background-repeat: no-repeat;
    padding: 7px 12px;
}
.error_input{
	/*background-color: #fab1a0;*/
	border-bottom:5px solid rgba(204,11,66,1);
}
#calculer{
	background: rgb(255,255,255);
	background: linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(249,245,245,1) 100%);
	border:solid 1px white;
	color:#3c3c3c;
	padding: 12px 22px;
}
#calculer:hover{
	background: rgb(246,241,241);
background: linear-gradient(135deg, rgba(246,241,241,1) 0%, rgba(245,239,239,1) 100%);
	color:black;
}
.load_calcul{
	position: absolute;
	top:150px;
}
.sub{
	margin-top:20px;
}
.vehicule{
	margin-top:10px;
	margin-bottom:15px;
}

.slide-enter-active {
  transition: all .3s ease;
}
.slide-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-enter, .slide-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}


@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

@media all and (max-width: 1200px) {
	.form-group{
		 background:#22417B;
	}
}

@media all and (max-width: 800px) {
	.simu-input{
		width:200px;
	}
}



</style>


// WEBPACK FOOTER //
// src/components/Simulateur.vue